import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV_LINKS } from "@/lib/data";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? "backdrop-blur-xl bg-[#121212]/85 border-b border-[#F5ECD7]/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 flex items-center justify-between h-16 md:h-20">
        <Link
          to="/"
          data-testid="logo-link"
          className="font-display text-[#F5ECD7] text-xl md:text-2xl tracking-tighter"
        >
          #<span className="text-[#C99C3A]">Taco</span>Soul
        </Link>

        <nav className="hidden lg:flex items-center gap-7">
          {NAV_LINKS.slice(0, 8).map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              data-testid={`nav-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `text-[13px] uppercase tracking-[0.15em] font-medium transition-colors ${
                  isActive ? "text-[#C99C3A]" : "text-[#F5ECD7]/80 hover:text-[#C99C3A]"
                }`
              }
              end={link.to === "/"}
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/book"
            data-testid="cta-book-nav"
            className="hidden md:inline-flex btn-gold !py-3 !px-5 !text-[11px]"
          >
            Book the Truck
          </Link>
          <button
            data-testid="mobile-menu-toggle"
            className="lg:hidden text-[#F5ECD7] p-2"
            onClick={() => setOpen((s) => !s)}
            aria-label="menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden border-t border-[#F5ECD7]/10 bg-[#121212]/95 backdrop-blur-xl"
        >
          <div className="px-5 py-6 flex flex-col gap-1">
            {NAV_LINKS.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                data-testid={`mobile-nav-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `py-3 text-base font-display tracking-tight ${
                    isActive ? "text-[#C99C3A]" : "text-[#F5ECD7]"
                  }`
                }
                end={link.to === "/"}
              >
                {link.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
